import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { openInNewTab } from '@/helpers';
import { coursesApi } from '@/services/course';

import { useLog } from './useLog';

export const useCertificate = (progress: number) => {
  const { hash } = useParams<{ hash: string }>();
  const { activity } = useLog();
  const courseState = coursesApi.endpoints.getCourse.useQueryState(hash);
  const reached = progress >= (courseState.data?.progress_percent ?? 0) && courseState.data?.has_certificate;

  const [refetch] = coursesApi.endpoints.getCertificate.useLazyQuery();

  const retryRef = useRef(0);
  useEffect(() => {
    if (reached && !courseState.data?.certificate_url && retryRef.current < 5) {
      const timeout = setTimeout(() => {
        refetch(hash);
        clearTimeout(timeout);
        retryRef.current++;
      }, 5000);
    }
  }, [courseState.data?.certificate_url, refetch, hash, reached]);

  return {
    pending: reached && !courseState.data?.certificate_url,
    reached: reached && courseState.data?.certificate_url,
    url: courseState.data?.certificate_url,
    onClick() {
      openInNewTab(courseState.data?.certificate_url);
      activity({
        context: 'viewCertificate',
        additionalData: {
          message: `Visualizou o certificado do curso ${courseState.data?.title}`,
          course_hash: hash
        }
      });
    }
  };
};
